import { Check, Loader2, LogIn, LogOut } from 'lucide-react';
import { useSoftphone } from '@/store/softphone';
import clsx from 'clsx';

/**
 * Pretty overlay shown while a queue *62/*63 feature-code call is in flight.
 * Hides the raw call internals (number, duration) from the user — they only
 * see "joining…" then "you're in".
 */
export function QueueActionOverlay() {
  const qa = useSoftphone((s) => s.queueAction);
  if (!qa) return null;

  const isLogin = qa.kind === 'login';
  const isDone = qa.status === 'done';

  const titlePending = isLogin ? 'Kuyruğa katılıyor…' : 'Kuyruktan çıkılıyor…';
  const titleDone = isLogin ? 'Kuyruğa katıldın' : 'Kuyruktan çıktın';
  const subPending = isLogin
    ? 'Çağrı dağıtımı seni dinliyor.'
    : 'Yeni çağrılar artık sana gelmeyecek.';
  const subDone = isLogin
    ? 'Hazır olduğun zaman çağrı alabilirsin.'
    : 'Tekrar katılmak için sağ üstteki butona dokun.';

  const ringColor = isDone
    ? isLogin ? 'from-emerald-500 to-emerald-600' : 'from-slate-500 to-slate-600'
    : isLogin ? 'from-emerald-400 to-emerald-500' : 'from-amber-400 to-amber-500';

  return (
    <div className="h-full flex flex-col items-center justify-center px-6 gap-4">
      <div className="relative">
        {!isDone && (
          <div
            className={clsx(
              'absolute inset-0 rounded-full bg-gradient-to-br opacity-40 blur-xl animate-pulse',
              ringColor,
            )}
          />
        )}
        <div
          className={clsx(
            'relative w-28 h-28 rounded-full bg-gradient-to-br text-white flex items-center justify-center shadow-lg transition-all duration-300',
            ringColor,
            isDone ? 'scale-100' : 'scale-95',
          )}
        >
          {isDone ? (
            <Check size={48} strokeWidth={3} className="drop-shadow-sm" />
          ) : (
            <Loader2 size={42} className="animate-spin" />
          )}
        </div>
      </div>

      <div className="text-center">
        <div className="flex items-center justify-center gap-1.5 text-lg font-semibold text-slate-800">
          {isLogin ? <LogIn size={16} className="text-emerald-600" /> : <LogOut size={16} className="text-slate-500" />}
          {isDone ? titleDone : titlePending}
        </div>
        <p className="text-sm text-slate-500 mt-1">{isDone ? subDone : subPending}</p>
      </div>
    </div>
  );
}
